import React, { Component, Fragment } from 'react';
import { Select, FormControl, MenuItem, InputLabel, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Pagination from '@mui/material/Pagination';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { controlRole } from '../../common/actions/controlRole';
import { isEmpty, isNull } from 'lodash';
import ModalChangeDns from '../../common/modal/modalChangeDns';
import Loading from '../../common/loading';
import { setHour } from '../../utility';

export default class FormFiltersPlaylist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // quale campo ordinare
            fieldOrder: '',

            // quanti player vuoi visualizzare
            numberPlaylist: '25',

            // numerpo di pagina selezionato
            currentNumberPage: '1',
            changeNumberPage: false,

            // tipo di ordinamento
            typeOrder: null,

            // inizializzazione dell'array filters
            filterUrl: '',
            filterName: '',
            filterId: '',
            filterCreatedAtStart: null,
            filterCreatedAtEnd: null,

            hasClickChangeDns: false,
            dataDns: {},
            modal: false
        }

        this.setChange = this.setChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }


    /**
     * Chiama il BE e ritorna la lista degli utenti in base ai parametri di ricerca inseriti
     */
    getAllPlayList = () => {
        let params = {
            'elementsByPage': this.state.numberPlaylist,
            'page': this.state.changeNumberPage ? this.state.currentNumberPage : 1,
            'sortField': this.state.fieldOrder,
            'sortType': this.state.typeOrder,
            'filters[0][Source]': this.state.filterUrl,
            'filters[1][Title]': this.state.filterName,
            'filters[2][DeviceId]': this.state.filterId,
            'filters[3][CreatedAtStart]': this.state.filterCreatedAtStart === null ? null : setHour(this.state.filterCreatedAtStart),
            'filters[4][CreatedAtEnd]': this.state.filterCreatedAtEnd === null ? null : setHour(this.state.filterCreatedAtEnd)
        }

        setTimeout(() => {
            this.props.getAllPlayList(params);
        }, 500);

        if (!this.state.changeNumberPage) {
            this.setState({
                currentNumberPage: 1
            });
        }

        if (this.state.changeNumberPage) {
            this.setState({
                changeNumberPage: false,
            });
        }
    }

    setChange = (event, page) => {
        this.setState({ [event.target.name]: event.target.value });

        if (event.target.name === '' || event.target.name === undefined) {
            this.setState({
                currentNumberPage: page,
                changeNumberPage: true
            });

            setTimeout(() => {
                this.getAllPlayList();
            }, 500);
        }

        if (event.target.name === 'numberPlaylist' || event.target.name === 'typeOrder') {
            setTimeout(() => {
                this.getAllPlayList();
            }, 200);
        }
    }

    setCreatedAtStart = (newDate) => {
        this.setState({ filterCreatedAtStart: newDate });
    }

    setCreatedAtEnd = (newDate) => {
        this.setState({ filterCreatedAtEnd: newDate });
    }

    /**
     * Se decido di cambiare il numero dei player.
     * 
     * @param {*} number 
     */
    setNumberPlaylistForSearch = (number) => {
        this.setState({ numberPlaylist: number });
        setTimeout(() => {
            this.getAllPlayList();
        }, 200);
    }

    /**
     * Se viene premuto il tasto enter (Invio) avvia una ricerca
     */
    clickEnter = (event) => {
        if (event.keyCode === 13) {
            this.getAllPlayList();
        }
    }

    // Resetta tutti i filtri
    resetFilter = () => {
        this.setState({
            numberPlaylist: '25',
            currentNumberPage: '1',

            fieldOrder: '',
            typeOrder: null,

            filterUrl: '',
            filterName: '',
            filterId: '',
            filterCreatedAtStart: null,
            filterCreatedAtEnd: null
        });

        setTimeout(() => {
            this.getAllPlayList();
        }, 300);
    }

    hasClickChangeDns = () => {
        if (
            isEmpty(this.state.filterName) &&
            isEmpty(this.state.filterUrl) &&
            isEmpty(this.state.filterId) &&
            isNull(this.state.filterCreatedAtStart) &&
            isNull(this.state.filterCreatedAtEnd)
        ) {
            this.props.errorNotify('Filtra prima di utilizzare il cambio Dns');

        } else {
            this.setState({
                hasClickChangeDns: true,
                dataDns: {
                    title: this.state.filterName,
                    source: this.state.filterUrl,
                    createdAtStart: this.state.filterCreatedAtStart === null ? null : setHour(this.state.filterCreatedAtStart),
                    createdAtEnd: this.state.filterCreatedAtEnd === null ? null : setHour(this.state.filterCreatedAtEnd),
                    deviceId: this.state.filterId
                }
            });

            setTimeout(() => {
                this.setState(prevState => ({ modal: !prevState.modal }));
            }, 200);
        }
    }

    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
        this.setState({ hasClickChangeDns: false });
    }

    render() {
        const { role, player } = this.props;

        return (
            <Fragment>
                {player.isLoading && <Loading />}
                <div className="row itemForSearch">
                    <div className="col-12 itemForSearch">
                        <TextField
                            name="filterUrl"
                            variant='standard'
                            value={this.state.filterUrl}
                            onChange={this.setChange}
                            onKeyDown={this.clickEnter}
                            label="URL Playlist"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 itemForSearch">
                        <TextField
                            name="filterName"
                            variant='standard'
                            value={this.state.filterName}
                            onChange={this.setChange}
                            onKeyDown={this.clickEnter}
                            label="Titolo Playlist"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <button
                            className={this.props.player.elementForPagePlaylist === '10' ? "btnAround selected" : "btnAround"}
                            onClick={() => this.setNumberPlaylistForSearch('10')}
                        > 10 </button>
                        <button
                            className={this.props.player.elementForPagePlaylist === '25' ? "btnAround selected" : "btnAround"}
                            onClick={() => this.setNumberPlaylistForSearch('25')}
                        > 25 </button>
                        <button
                            className={this.props.player.elementForPagePlaylist === '50' ? "btnAround selected" : "btnAround"}
                            onClick={() => this.setNumberPlaylistForSearch('50')}
                        > 50 </button>
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <Pagination
                            boundaryCount={2}
                            count={parseInt(this.props.player.totalPagesPlaylist) || 0}
                            page={parseInt(this.state.currentNumberPage)}
                            onChange={this.setChange}
                            color="primary"
                            showFirstButton
                            showLastButton
                            size="small"
                        />
                    </div>
                </div>

                <div className="row itemForSearch">
                    <div className="col-12 text-center">
                        <button className="btn btn-primary" style={{ 'margin': '10px' }} onClick={() => this.getAllPlayList()}>
                            Cerca
                        </button>
                        <button className="btn btn-secondary" style={{ 'margin': '10px' }} onClick={this.resetFilter}>
                            Reset
                        </button>
                    </div>

                    <div className="col-12 text-center">
                        {
                            controlRole(role.player, "api/Player/PlayLists/ChangeDns", "POST") &&
                            <Fragment>
                                <button
                                    className="btn btn-warning"
                                    style={{ 'margin': '10px' }}
                                    onClick={() => { this.hasClickChangeDns() }}
                                >
                                    Change Dns
                                </button>
                            </Fragment>
                        }
                    </div>
                </div>

                <Accordion className="myAccordion">
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography>Altri filtri</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Typography component="div">
                            <div className="row">
                                <div className="col-12 itemForSearch">
                                    <FormControl className='customSelect'>
                                        <InputLabel>Come vuoi ordinare?</InputLabel>
                                        <Select
                                            labelId="fieldOrderPlayersLabel"
                                            name="fieldOrder"
                                            variant='standard'
                                            value={this.state.fieldOrder}
                                            onChange={this.setChange}
                                        >
                                            <MenuItem value={'Title'}>Titolo</MenuItem>
                                            <MenuItem value={'Source'}>Url</MenuItem>
                                            <MenuItem value={'DeviceId'}>Device ID</MenuItem>
                                            <MenuItem value={'CreatedAt'}>CreatedAt</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                <div className="col-12 itemForSearch">
                                    <FormControl disabled={this.state.fieldOrder === ''} className='customSelect'>
                                        <InputLabel>Tipo di Ordinamento</InputLabel>
                                        <Select
                                            labelId="typeOrderLabel"
                                            name="typeOrder"
                                            variant='standard'
                                            value={this.state.typeOrder}
                                            onChange={this.setChange}
                                        >
                                            <MenuItem value={true}>Crescente [A-Z]</MenuItem>
                                            <MenuItem value={false}>Decrescente [Z-A]</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="row itemForSearch">
                                <div className="col-12">
                                    <TextField
                                        name="filterId"
                                        variant='standard'
                                        value={this.state.filterId}
                                        onChange={this.setChange}
                                        onKeyDown={this.clickEnter}
                                        label="Device ID"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="col-12 itemForSearch">
                                        <DatePicker
                                            id="filterCreatedAtStart"
                                            variant="inline"
                                            label="Creazione da"
                                            name="filterCreatedAtStart"
                                            value={this.state.filterCreatedAtStart}
                                            onChange={(newValue) => this.setCreatedAtStart(isNull(newValue) ? null : dayjs(newValue.$d))}
                                            format="DD/MM/YYYY"
                                        />
                                    </div>

                                    <div className="col-12 itemForSearch">
                                        <DatePicker
                                            id="filterCreatedAtEnd"
                                            variant="inline"
                                            label="Fino a"
                                            name="filterCreatedAtEnd"
                                            value={this.state.filterCreatedAtEnd}
                                            onChange={(newValue) => this.setCreatedAtEnd(isNull(newValue) ? null : dayjs(newValue.$d))}
                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </LocalizationProvider>
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {
                    this.state.hasClickChangeDns &&
                    <ModalChangeDns
                        titleModal='Modifica Dns'
                        stateModal={this.state.modal}
                        toggle={this.toggleModal}

                        dataDns={this.state.dataDns}
                        sendData={this.props.changeDns}

                        errorNotify={this.props.errorNotify}
                    />
                }
            </Fragment>
        )
    }
}